import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeStatusKey, deleteKey, getKeys } from 'redux/apiKeysSlice';
import ItemKey from './ItemKey';
import { DeleteModal } from 'components/common/DeleteModal';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

const ListaKeys = ({ callToast }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);
  const apiKeyArray = useSelector(state => state.apiKeys.keys);

  const FetchData = async () => {
    setIsLoading(true);
    await dispatch(getKeys(userLogged.id));
    setIsLoading(false);
  };

  const DeleteItem = async id => {
    const res = await dispatch(deleteKey(id));
    if (res.status < 300) {
      callToast(
        '¡API Key eliminada!',
        'La API Key fue eliminada correctamente.',
        'Justo ahora'
      );
      FetchData();
    } else
      callToast(
        'Algo salió mal...',
        'La API Key no pudo ser eliminada. Inténtelo de nuevo.',
        'Justo ahora'
      );
  };

  const ChangeStatus = async id => {
    const res = await dispatch(changeStatusKey(id));
    if (res.status < 300) {
      callToast(
        'Estado cambiado',
        'El estado de la API Key fue cambiado correctamente.',
        'Justo ahora'
      );
      FetchData();
    } else
      callToast(
        'Algo salió mal...',
        'El estado de la API Key no pudo ser cambiado. Inténtelo de nuevo.',
        'Justo ahora'
      );
  };

  useEffect(() => {
    userLogged && FetchData();
  }, [userLogged]);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <Spinner
            animation="border"
            style={{
              color: '#2c7be5'
            }}
          />
        </div>
      ) : (
        apiKeyArray.map((apikey, index) => (
          <div key={apikey.id}>
            <ItemKey
              id={apikey.id}
              data={apikey}
              isFirst={index === 0}
              handleDelete={() => setOpenDeleteModal(apikey)}
              changeStatus={() => ChangeStatus(apikey.id)}
            />
          </div>
        ))
      )}
      <DeleteModal
        openDeleteModal={!!openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        element={openDeleteModal.name}
        setDeleting={() => DeleteItem(openDeleteModal.id)}
      />
    </>
  );
};

ListaKeys.propTypes = {
  callToast: PropTypes.func.isRequired
};

export default ListaKeys;
